import{FieldLabel as e}from"./src/FieldLabel.js";customElements.define("sp-field-label",e);
//# sourceMappingURL=sp-field-label.js.map
